




export function setupSearch () {
    const searchForm = document.querySelector('.searchform');
    const searchButton = document.querySelector('.toggle-search');
    const searchField = searchForm.querySelector('input');

    searchButton
        .addEventListener('mousedown', evt => {
            evt.preventDefault();

            if ( document.querySelector('body').classList.contains('mobile-nav-active') ) {
                searchForm.submit();
            }

            if ( !searchForm.classList.contains('active') ) {
                searchField.focus();
            } else {
                searchField.blur();
            }
        });

    searchField.addEventListener('focus', () => {
        searchForm.classList.add('active');
    });

    searchField.addEventListener('blur', () => {
        searchForm.classList.remove('active');
    });
}
